import api from "@/services/api";

// Get spots
export const getSpots = async (
  page,
  perPage,
  sortBy = "id.asc",
  searchQuery = ""
) => {
  try {
    const response = await api.get("/v1/admin/places", {
      params: {
        sortBy,
        page,
        perPage,
        search: searchQuery,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching spots:", error);
    throw error;
  }
};

// Get spot by ID
export const getSpotById = async (id) => {
  try {
    const response = await api.get(`/v1/admin/places/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching spot:", error);
    throw error;
  }
};

// Create spot
export const createSpot = async (spotData) => {
  try {
    const response = await api.post("/v1/admin/places", spotData);
    return response.data;
  } catch (error) {
    console.error("Error creating spot:", error);
    throw error;
  }
};

// Update spot
export const updateSpot = async (id, spotData) => {
  try {
    const response = await api.put(`/v1/admin/places/${id}`, spotData);
    return response.data;
  } catch (error) {
    console.error("Error updating spot:", error);
    throw error;
  }
};

// Delete spot
export const deleteSpot = async (id) => {
  try {
    await api.delete(`/v1/admin/places/${id}`);
    return id;
  } catch (error) {
    console.error("Error deleting spot:", error);
    throw error;
  }
};

// Add new function to get provinces
export const getProvinces = async () => {
  try {
    const response = await api.get("/v1/fe/provinces");
    return response.data.data.data; // Adjusting to match the response structure
  } catch (error) {
    console.error("Error fetching provinces:", error);
    throw error;
  }
};

// Add new function to get cities by province ID
export const getCities = async (provinceId) => {
  try {
    console.log("getCities - Received provinceId:", provinceId);
    console.log("getCities - provinceId type:", typeof provinceId);

    const response = await api.get("/v1/fe/cities", {
      params: {
        provinceId: provinceId,
      },
    });

    console.log("Raw API response:", response.data);

    // Validate response structure
    if (!response.data || !response.data.data || !response.data.data.data) {
      console.error("Unexpected API response structure:", response.data);
      return [];
    }

    const cities = response.data.data.data.map((city) => ({
      id: city.id,
      name: city.name,
    }));

    console.log("Mapped cities:", cities);
    console.log("Number of cities:", cities.length);

    return cities;
  } catch (error) {
    console.error("Detailed error in getCities:", error);

    // Log full error response if available
    if (error.response) {
      console.error("Error response:", error.response.data);
    }

    throw error;
  }
};
